// 사용 예시:
//   <div data-controller="ad-banner-impression"
//        data-ad-banner-impression-id-value="<%= banner.id %>"
//        data-ad-banner-impression-creative-id-value="<%= banner.current_creative_id %>">
//     ...배너 마크업...
//   </div>
//
// 노출 측정 규칙 (GA4 / GTM Element Visibility 기준에 맞춤):
//   - 요소가 viewport 50% 이상 보이는 즉시 1회 노출로 인정 (GTM "Minimum Percent Visible" 기본값 50%, 최소 노출시간 없음)
//   - dwell(연속 노출 시간) 조건 없음 → 빠르게 스크롤로 지나가도 GA 와 동일하게 카운트
//   - 같은 페이지 라이프사이클(connect~disconnect) 동안 배너당 1회만 기록 (per-pageload dedup)
//   - 페이지 새로고침, 다른 페이지로 이동, 다른 탭에서 본 경우는 별개의 노출로 카운트
//
// 전송:
//   - navigator.sendBeacon 우선 사용 → 페이지 이탈(탭 닫기/외부 링크 이동) 중에도 손실 없이 전송
//   - sendBeacon 미지원/실패 시 axios POST 로 폴백
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";

export default class extends Controller {
  static values = {
    id: Number,
    // 지금 걸려 있는 소재(AdBannerCreative) id. 노출을 소재 단위로 나눠 집계하기 위해 함께 보낸다.
    // 값이 없으면 서버가 그 날 걸려 있던 소재로 되돌려 붙인다.
    creativeId: Number,
  };

  connect() {
    if (!this.idValue) return;
    this.reported = false;

    if (typeof IntersectionObserver === "undefined") {
      this.report();
      return;
    }

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      threshold: [0, 0.5],
    });
    this.observer.observe(this.element);
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  onIntersect(entries) {
    if (this.reported) return;
    const entry = entries[0];
    // 50% 이상 보이는 즉시 기록 (dwell 없음)
    if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
      this.report();
    }
  }

  report() {
    if (this.reported) return;
    this.reported = true;
    this.sendImpression();
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  sendImpression() {
    const path = this.creativeIdValue
      ? `/spots/${this.idValue}/view?c=${this.creativeIdValue}`
      : `/spots/${this.idValue}/view`;
    // 페이지 이탈 중에도 전송이 보장되는 sendBeacon 우선
    if (navigator.sendBeacon && navigator.sendBeacon(path)) return;
    // 폴백: sendBeacon 미지원 혹은 큐잉 실패 시
    api.post(path).catch(() => {
      // 노출 기록 실패는 무시
    });
  }
}
